// eslint-disable-next-line @typescript-eslint/ban-types
type RenderProp<P = {}> = (props: P) => React.ReactElement<any>

export function isRenderProp(children: any): children is RenderProp {
  return typeof children === 'function'
}
